export const FORM_AI_DOCUMENT_ACCEPT = '.pdf,.docx,.txt,.xlsx';
export const FORM_AI_DOCUMENT_MAX_SIZE = 25 * 1024 * 1024;

export function validateFormAiDocument(file) {
  if (!file) return '';
  if (!/\.(pdf|docx|txt|xlsx)$/i.test(file.name || '')) {
    return 'Selecione um documento PDF, DOCX, TXT ou XLSX.';
  }
  if (file.size > FORM_AI_DOCUMENT_MAX_SIZE) return 'O documento deve ter no máximo 25 MB.';
  if (!file.size) return 'O documento está vazio.';
  return '';
}

export function buildFormAiRequest(prompt, file) {
  const validationError = validateFormAiDocument(file);
  if (validationError) throw new Error(validationError);
  if (!file) return { url: '/ai/forms/generate', data: { prompt: prompt.trim() } };
  const data = new FormData();
  data.append('file', file);
  if (prompt.trim()) data.append('prompt', prompt.trim());
  return { url: '/ai/forms/generate-from-document', data };
}

const labelKey = (label) => String(label || '').trim().toLocaleLowerCase('pt-BR');
const uniqueId = (base, used, fallback) => {
  const normalized = String(base || fallback).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase() || fallback;
  let id = normalized;
  let index = 2;
  while (used.has(id)) id = `${normalized}-${index++}`;
  used.add(id);
  return id;
};

// Keep source IDs mapped after normalization, collisions and reuse of existing groups.
export function normalizeFormAiSuggestion(schema = {}, existingGroups = [], existingFields = [], cleanLabel = (label) => String(label || '').trim()) {
  const usedGroups = new Set(existingGroups.map((group) => group.id));
  const groupLabels = new Map();
  existingGroups.forEach((group) => {
    const key = labelKey(group.label);
    groupLabels.set(key, [...(groupLabels.get(key) || []), group.id]);
  });
  const groupIds = new Map(existingGroups.map((group) => [group.id, group.id]));
  const groups = [];
  (Array.isArray(schema.groups) ? schema.groups : []).forEach((group, index) => {
    const label = cleanLabel(group.label) || `Grupo sugerido ${index + 1}`;
    const key = labelKey(label);
    const matchingExistingGroups = groupLabels.get(key) || [];
    const matchingIdIndex = matchingExistingGroups.indexOf(group.id);
    let id = matchingExistingGroups.splice(matchingIdIndex >= 0 ? matchingIdIndex : 0, 1)[0];
    if (!id) {
      id = uniqueId(group.id || label, usedGroups, `grupo-${index + 1}`);
      groups.push({ ...group, id, label });
    }
    if (group.id) groupIds.set(group.id, id);
    groupIds.set(id, id);
  });
  const usedFields = new Set(existingFields.map((field) => field.id));
  const fieldKey = (label, groupId) => JSON.stringify([groupId || '', labelKey(label)]);
  const existingFieldCounts = new Map();
  existingFields.forEach((field) => {
    const key = fieldKey(field.label, field.groupId);
    existingFieldCounts.set(key, (existingFieldCounts.get(key) || 0) + 1);
  });
  const fields = [];
  (Array.isArray(schema.fields) ? schema.fields : []).forEach((field, index) => {
    const label = cleanLabel(field.label);
    const groupId = groupIds.get(field.groupId) || '';
    const key = fieldKey(label, groupId);
    if (!label) return;
    const matchingExistingFields = existingFieldCounts.get(key) || 0;
    if (matchingExistingFields) {
      existingFieldCounts.set(key, matchingExistingFields - 1);
      return;
    }
    const id = uniqueId(field.id || label, usedFields, `campo-${index + 1}`);
    fields.push({ ...field, id, label, groupId });
  });
  return { ...schema, groups, fields };
}
